export default "__VITE_ASSET__MtHC9ou1__"